module.exports = __webpack_public_path__ + "static/media/profile_pic.18b60175.jpg";